import React from 'react';
import PropTypes from 'prop-types';
import { Descriptions } from 'antd';
import { floor } from 'lodash';
import {
  dateToDDMMYYYY,
  dateToDDMMYYYYTTMMUniversal,
  no1000Seperator
} from '../../common/utils/formatter';
import AlertsLevelFraudComponent from './FraudAlertLevelComponent';

/**
 * DescriptionsComponent
 * @param props
 * @returns {*}
 * @constructor
 */
const DescriptionsComponent = (props) => {
  const itemStyle = { fontWeight: 500, fontSize: 11, color: '#31394D' };
  const {
    id,
    challengerid = '-',
    typeOfRun = '-',
    runTriggerDate = '-',
    runCompletionDate = '-',
    newAlerts = 0,
    noOfTypologies = '-',
    validationCompletion = 0,
    trueAlertCnt = '-',
    falseAlertCnt = '-',
    trainingStarted = '-',
    trainingCompleted = '-',
    trainingDateRange,
    predictionStarted = '-',
    predictionCompleted = '-',
    predictionDateRange,
    noOfCustomer = 0,
    noOfTransaction = 0,
    predictionRunId = '-',
    numTrueAlert = 0,
    numFalseAlert = 0,
    typologies = [],

    highLevelAlert = 0,
    goodLevelAlert = 0,
    lowLevelAlert = 0,

    highQualityAlert = 0,
    goodQualityAlert = 0,
    lowQualityAlert = 0,

    isFraudPrevention,
    actionCount = {},
    typologyActionList = []
  } = props;

  const calcuLevelAlertPer = (levelAlert) => {
    const inPercent =
      (levelAlert / (highLevelAlert + goodLevelAlert + lowLevelAlert)) * 100;
    return inPercent ? `${floor(inPercent, 1)} %` : 0;
  };

  const calcuTrueFalseAlertPer = (numAlert) => {
    const inPercent = (numAlert / (numTrueAlert + numFalseAlert)) * 100;
    return inPercent ? `${floor(inPercent, 2)} %` : 0;
  };

  const parseFTStringToDate = (str) => {
    return (
      <div style={{ lineHeight: '1.2' }}>
        {dateToDDMMYYYY(str?.from)}
        &nbsp;-&nbsp;
        {dateToDDMMYYYY(str?.to)}
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', border: '1px solid #D0D7E3', padding: 20 }}>
      {/* COLUMN 1 */}
      <Descriptions style={{ flexBasis: '22%' }} size={'small'} column={1}>
        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item contentStyle={itemStyle}>
          Type of Run : {typeOfRun}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        {/* <Descriptions.Item labelStyle={itemStyle} label="Run Trigger Date ">
          {dateToDDMMYYYYTTMM(runTriggerDate)}
        </Descriptions.Item> */}

        {/* Challenger Day 0/Day n/Current Champion */}
        {/* <Descriptions.Item labelStyle={itemStyle} label="Run Completion Date ">
          {dateToDDMMYYYYTTMM(runCompletionDate)}
        </Descriptions.Item> */}

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label={
            isFraudPrevention ? 'Number of Variants' : 'Number of Typologies'
          }>
          <span style={{ fontSize: '11px' }}>{typologies.length}</span>
        </Descriptions.Item>
      </Descriptions>

      {/* COLUMN 2 */}
      <Descriptions style={{ flexBasis: '23%' }} size={'small'} column={1}>
        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Alerts Generated">
          {newAlerts}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Alert Level"></Descriptions.Item>
        <Descriptions.Item contentStyle={itemStyle}>
          {isFraudPrevention ? (
            <AlertsLevelFraudComponent
              actionCount={actionCount}
              actionList={typologyActionList}
            />
          ) : (
            <>
              <span style={{ color: 'red' }}>
                High : {calcuLevelAlertPer(highLevelAlert)} ({highLevelAlert}){' '}
              </span>
              <span style={{ color: 'orange', margin: '0 5px' }}>
                Good : {calcuLevelAlertPer(goodLevelAlert)} ({goodLevelAlert}){' '}
              </span>
              <span style={{ color: '#00d600' }}>
                Low : {calcuLevelAlertPer(lowLevelAlert)} ({lowLevelAlert}){' '}
              </span>
            </>
          )}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Validation Completion">
          {validationCompletion}
        </Descriptions.Item>

        {/* Current Champion (In Production)*/}
        <Descriptions.Item contentStyle={itemStyle}>
          True Alerts: {calcuTrueFalseAlertPer(numTrueAlert)} ({numTrueAlert}{' '}
          alerts)
        </Descriptions.Item>

        {/* Current Champion (In Production)*/}
        <Descriptions.Item contentStyle={itemStyle}>
          False Alerts: {calcuTrueFalseAlertPer(numFalseAlert)} ({numFalseAlert}{' '}
          alerts)
        </Descriptions.Item>
      </Descriptions>

      {/* COLUMN 3 */}
      <Descriptions style={{ flexBasis: '30%' }} size={'small'} column={1}>
        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Training Started On">
          {dateToDDMMYYYYTTMMUniversal(trainingStarted)}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Training Completed On">
          {dateToDDMMYYYYTTMMUniversal(trainingCompleted)}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Training Model Date Range">
          {trainingDateRange ? parseFTStringToDate(trainingDateRange) : '-'}
        </Descriptions.Item>
      </Descriptions>

      {/* COLUMN 4*/}
      <Descriptions style={{ flexBasis: '25%' }} size={'small'} column={1}>
        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Prediction Pipeline Started on">
          {dateToDDMMYYYYTTMMUniversal(predictionStarted)}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Prediction Completed on">
          {dateToDDMMYYYYTTMMUniversal(predictionCompleted)}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Prediction Date Range">
          {predictionDateRange ? parseFTStringToDate(predictionDateRange) : '-'}
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item labelStyle={itemStyle} label="Customers Processed">
          <span style={{ fontSize: '11px' }}>
            {no1000Seperator(noOfCustomer)}
          </span>
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Transactions Processed">
          <span style={{ fontSize: '11px' }}>
            {no1000Seperator(noOfTransaction)}
          </span>
        </Descriptions.Item>

        {/* Challenger Day 0/Day n/Current Champion */}
        <Descriptions.Item
          labelStyle={itemStyle}
          label="Prediction Pipeline Run ID">
          <span style={{ fontSize: '11px' }}>{predictionRunId}</span>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

DescriptionsComponent.propTypes = {
  id: PropTypes.number,
  challengerid: PropTypes.number,
  typeOfRun: PropTypes.string,
  runTriggerDate: PropTypes.string,
  newAlerts: PropTypes.number,
  runCompletionDate: PropTypes.string,
  noOfTypologies: PropTypes.number,
  validationCompletion: PropTypes.number,
  trueAlertCnt: PropTypes.number,
  falseAlertCnt: PropTypes.number,
  trainingStarted: PropTypes.string,
  trainingCompleted: PropTypes.string,
  trainingDateRange: PropTypes.string,
  predictionStarted: PropTypes.string,
  predictionCompleted: PropTypes.string,
  predictionDateRange: PropTypes.string,
  noOfCustomer: PropTypes.number,
  noOfTransaction: PropTypes.number,
  predictionRunId: PropTypes.number,
  typologies: PropTypes.array,
  flag: PropTypes.oneOf(['challenger'])
};

export default DescriptionsComponent;
